// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"dfa48f29","114":"1bb9a015","146":"67b33547","728":"c82aa812","914":"b60f032c"}[chunkId] + ".css";
};